import { render, staticRenderFns } from "./ReportesBajasTransitoBase.vue?vue&type=template&id=ea760bdc&"
import script from "./ReportesBajasTransitoBase.vue?vue&type=script&lang=ts&"
export * from "./ReportesBajasTransitoBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ea760bdc', component.options)
    } else {
      api.reload('ea760bdc', component.options)
    }
    module.hot.accept("./ReportesBajasTransitoBase.vue?vue&type=template&id=ea760bdc&", function () {
      api.rerender('ea760bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ReportesBajasTransito/ReportesBajasTransitoBase.vue"
export default component.exports